.value-field {
    width: 88px;
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.value-field-small {
    composes: value-field;
    width: 50px;
}

.total-value {
    /* To match the textfields alignment */
    height: 31px;
    display: flex;
    align-items: center;
}

.input-with-suffix {
    position: relative;
}

.suffix {
    position: absolute;
    right: 8px;
    top: 50%;
    transform: translateY(-50%);
    color: var(--grey);
    pointer-events: none;
}
